<footer class="quick-apply-footer">
  <app-logout-confirmation-modal
    [hidden]="modalIsHidden"
    (cancel)="modalIsHidden = true"
    [countryId]="countryId">
  </app-logout-confirmation-modal>
  <div *ngIf="!(dataService.isAuthenticated$ | async)" class="privacy-links">
    <span>{{"footer.privacy-policy" | translate}}</span>
    <a mat-button color="primary" href="{{privacyPolicyUrlAquent}}"  id="privacy-policy-link" target="_blank">{{"footer.aquent" | translate}}</a>
    <mat-divider [vertical]="true" class="divider"></mat-divider>
    <a mat-button color="primary" href="{{privacyPolicyUrlSkill}}" *ngIf="!(dataService.isAuthenticated$ | async)" id="privacy-policy-link-skill" target="_blank">{{"footer.skill" | translate}}</a>
    <ng-container *ngIf="impressumUrl">
      <mat-divider [vertical]="true" class="divider"></mat-divider>
      <a mat-button color="primary" href="{{impressumUrl}}" id="impressum-link" target="_blank">{{"footer.impressum" | translate}}</a>
    </ng-container>
  </div>
  <div class="footer-container" *ngIf="dataService.isAuthenticated$ | async">
    <div class="privacy-links">
      <span>{{"footer.privacy-policy" | translate}}</span>
      <a mat-button color="primary" href="{{privacyPolicyUrlAquent}}" id="privacy-policy-link-auth" target="_blank">{{"footer.aquent" | translate}}</a>
      <mat-divider [vertical]="true" class="divider"></mat-divider>
      <a mat-button color="primary" href="{{privacyPolicyUrlSkill}}" id="privacy-policy-link-skill" target="_blank">{{"footer.skill" | translate}}</a>
      <ng-container *ngIf="impressumUrl">
        <mat-divider [vertical]="true" class="divider"></mat-divider>
        <a mat-button color="primary" href="{{impressumUrl}}" id="impressum-link-auth" target="_blank">{{"footer.impressum" | translate}}</a>
      </ng-container>
    </div>
    <div class="logout-container">
      <button mat-button color="primary" id="logout" class="logout-button" (click)="modalIsHidden = false">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.25 1.5H10.5L10.5 10.5H8.25V12H10.5C11.325 12 12 11.325 12 10.5L12 1.5C12 0.675 11.325 0 10.5 0H8.25V1.5ZM5.25 2.25L4.1925 3.3075L6.1275 5.25L0 5.25L0 6.75L6.1275 6.75L4.1925 8.6925L5.25 9.75L9 6L5.25 2.25Z" fill="#0077C8"/>
        </svg>
        <span>{{"footer.logout" | translate}}</span>
      </button>
    </div>
  </div>
</footer>
